<template>
  <div class="banner">
    <img :src="url" alt="banner" v-if="isLoaded">
    <vue-content-loading :width="310" :height="65" v-else>
      <rect cx="30" cy="30" width="310" r="30" height="65" x="0" />
    </vue-content-loading>
  </div>
</template>

<script>
import axios from 'axios'
import VueContentLoading from 'vue-content-loading'
export default {
  name: 'Banner',

  props: {
  },

  data () {
    return {
      url: null,
      isLoaded: false
    }
  },
  components: {
    VueContentLoading
  },
  computed: {
  },
  watch: {
    '$route.params': {
      handler (newVal, oldVal) {
        if ((newVal.category !== oldVal.category)) {
          this.getBanner()
        }
      }
    }
  },
  mounted () {
    this.getBanner()
  },

  methods: {
    getBanner () {
      let self = this

      if (self.$route.name === 'productsList' && self.$route.params.category) {
        let category
        switch (self.$route.params.category) {
          case 'recent':
            category = 'recent'
            break
          case 'magazine':
            category = 'magazine'
            break
          case 'book':
            category = 'book'
            break
          case 'package':
            category = 'package'
            break
          case 'digital':
            category = 'digiLearn'
            break
          case 'livepen':
            category = 'smartpen'
            break
        }
        axios.get(`/ad/${category}`)
          .then((response) => {
            if (response.data[0]) {
              self.onImageLoaded(response.data[0].image_url)
              self.url = response.data[0].image_url
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    onImageLoaded (url) {
      let self = this
      self.isLoaded = false
      var image = new Image()
      image.src = url

      if (image.complete) {
        self.isLoaded = true
      } else {
        image.onload = () => {
          self.isLoaded = true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  img {
    width: 100%;
  }
</style>
